// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const File = t.struct({
    className: t.String,
    classType: t.String,
    fileName: t.String,
    fileSize: t.maybe(t.Number),
    objectKey: t.String,
    serialNumber: t.String,
    source: t.String
}, {
    name: 'File',
    strict: true
});

export const getDefaultState = () => new File({
    className: '',
    classType: '',
    fileName: '',
    fileSize: 0,
    objectKey: '',
    serialNumber: '',
    source: ''
});

export default File;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/file.js